<template>
  <div>
    <div class="select_wrap">
      <div class="remember">
        <p>
          <span style="margin-right:7px">* 相关文件：
          <a href="http://rescdn.yioks.cn/zuxie/%E4%B8%AD%E5%9B%BD%E8%B6%B3%E5%8D%8F%E8%BF%90%E5%8A%A8%E8%83%BD%E5%8A%9B%E6%B5%8B%E8%AF%95%E5%9F%B9%E8%AE%AD%E8%A7%86%E9%A2%91.mp4" target="_blank">
            运动能力测试培训视频</a
          ></span>
          <span style="margin-right:7px">
          <a href="http://rescdn.yioks.cn/zuxie/%E4%B8%AD%E5%9B%BD%E8%B6%B3%E5%8D%8F%E8%BF%90%E5%8A%A8%E8%83%BD%E5%8A%9B%E6%B5%8B%E8%AF%95%E6%96%B9%E6%B3%95%E6%8C%87%E5%AF%BC.pdf" target="_blank">
            运动能力测试方法指导（pdf）</a
          ></span>
          <a href="/uploads/sportsAabilityFile/YO-YO Test IER1(1).mp3" target="_blank">
            IR1(音频文件)</a
          >
          <a
            target="_blank"
            href="/uploads/sportsAabilityFile/yyir2-male-beeps(1).mp3"
            style="margin-left: 10px"
          >
            IR2(音频文件)</a
          >
          <a
            target="_blank"
            href="/uploads/sportsAabilityFile/yoyo测试过程用表.pdf"
            style="margin-left: 10px"
          >
            YOYO测试流程（pdf）</a
          >
        </p>
      </div>
      <div class="select_box">
        <template v-if="userRole !== 'coach'">
          <select
            v-model="selectVal.organUuid"
            class="yioks_select"
            @change="changeOrg"
          >
            <option v-if="organList.length > 1" value="">全部区体育行政部门</option>
            <option
              v-for="item in organList"
              :key="item.organUuid"
              :value="item.organUuid"
            >
              {{ item.organShortName }}
            </option>
          </select>
          <select
            v-model="selectVal.youthUuid"
            class="yioks_select"
            @change="changeCenter"
          >
            <option v-if="centerList.length !== 1" value="">全部培训机构</option>
            <option
              v-for="item in centerList"
              :key="item.uuid"
              :value="item.uuid"
            >
              {{ item.youthShortName }}
            </option>
          </select>
          <select
            v-model="selectVal.squadUuid"
            class="yioks_select"
            @change="changeQuery(true)"
          >
            <option v-if="squadList.length !== 1" value="">全部球队</option>
            <option v-for="item in squadList" :key="item.uuid" :value="item.uuid">
              {{ item.shortName }}
            </option>
          </select>
        </template>
        <template v-else>
          <select
            v-model="selectVal.squadUuid"
            class="yioks_select"
            @change="changeQuery(true)"
          >
            <option value="">全部球队</option>
            <option
              v-for="item in squadCoachList"
              :key="item.key"
              :value="item.value">
              {{ item.label }}
            </option>
          </select>
        </template>


      </div>
<!--      <div class="search_box">-->
<!--        <input-->
<!--          v-model.trim="selectVal.seacherString"-->
<!--          type="text"-->
<!--          class="yioks_input"-->
<!--          style="width: 200px"-->
<!--          placeholder="请输入关键字"-->
<!--          @keyup.enter="changeQuery(true)"-->
<!--        />-->
<!--        <div class="yioks_btn" @click="changeQuery(true)">搜索</div>-->
<!--      </div>-->
    </div>
    <div class="list_wrap">
      <div v-if="showList" class="table">
        <div class="thead">
          <div class="tr">
            <div class="th seq"><strong>序号</strong></div>
            <div class="th organName"><strong>单位</strong></div>
            <div class="th squadName"><strong>测试球队</strong></div>
            <div class="th testTime"><strong>测试时间</strong></div>
            <!--<div class="th testAddress"><strong>测试批次</strong></div>-->
            <!--<div class="th testName"><strong>测试联系人</strong></div>-->
            <div class="th opt"><strong>操作</strong></div>
          </div>
        </div>
        <div class="scrollArea">
          <vue-scroll>
            <div class="tbodyWrap">
              <div class="tbody">
                <div v-for="(item, index) in boby" :key="index" class="tr">
                  <div class="td seq">
                    <p>{{ index + 1 }}</p>
                  </div>
                  <div class="td organName" :title="`${item.organShortName}—${item.youthShortName}`">
                    <p>{{ item.organShortName + "—" + item.youthShortName }}</p>
                  </div>
                  <div class="td squadName">
                    <p :title="item.squadShortName">
                      {{ item.squadShortName }}
                    </p>
                  </div>
                  <div class="td testTime">
                    <p>{{ item.testTime | time }}</p>
                  </div>
                  <!--<div class="td testAddress">-->
                    <!--<p :title="item.templateTitle">{{ item.templateTitle }}</p>-->
                  <!--</div>-->
                  <!--<div class="td testName">-->
                    <!--<p>{{ item.linkMen }}</p>-->
                  <!--</div>-->
                  <div class="td opt">
                    <p>
                      <span class="item" @click="goDetail(item.uuid)"
                        >查看</span
                      >
                      <template v-if=" userRole !== 'system' && userRole !== 'admin'">
                        <span class="split" v-if="!item.templateDeleted && item.official===0">/</span>
                        <span class="item" v-if="!item.templateDeleted && item.official===0" @click="deletBoby(item.uuid)"
                        >删除</span
                        >
                      </template>
                      <template v-else>
                        <span class="split" v-if="!item.templateDeleted">/</span>
                        <span class="item" v-if="!item.templateDeleted" @click="deletBoby(item.uuid)"
                        >删除</span
                        >
                      </template>

                    </p>
                  </div>
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
      <yioks-loading v-if="loading" />
      <yioks-empty v-if="empty" />
    </div>
    <Pagination :total="total" :page.sync="page" />
    <yioks-tip
      :showTip="showTip"
      tipMsg="确定删除该测试数据吗？"
      @callback="isDelete"
    />
    <el-dialog
      :visible.sync="batchAdd"
      width="600px"
      title="批量导入运动能力测试"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      custom-class="yioks_alert2"
      @close="handleClose"
    >
      <el-form
        ref="batchInfo"
        :model="batchInfo"
        :rules="formRules"
        label-width="180px"
        style="height: 600px"
      >
        <vue-scroll ref="scroll" :ops="ops">
          <div style="margin-right: 30px">
            <template v-if="userRole !== 'coach'">
              <el-form-item label="管理单位" prop="organUuid">
                <el-select
                  v-model.trim="batchInfo.organUuid"
                  style="width: 100%"
                  placeholder="请选择管理单位"
                  @change="changeBathOrg"
                >
                  <el-option
                    v-for="item in batchOrganList"
                    :key="item.organUuid"
                    :value="item.organUuid"
                    :label="item.organShortName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="单位" prop="youthUuid">
                <el-select
                  v-model.trim="batchInfo.youthUuid"
                  style="width: 100%"
                  placeholder="请选择管理单位后再选择单位"
                  @change="changeBathCenter"
                >
                  <el-option
                    v-for="item in batchCenterList"
                    :key="item.uuid"
                    :value="item.uuid"
                    :label="item.youthShortName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择球队" prop="squadUuid">
                <el-select
                  v-model.trim="batchInfo.squadUuid"
                  style="width: 100%"
                  placeholder="请选择球队"
                  no-data-text="暂时没有球队，请前往球队管理添加球队"
                >
                  <el-option
                    v-for="item in batchSquadList"
                    :key="item.uuid"
                    :value="item.uuid"
                    :label="item.shortName"
                    :disabled="item.squadDissolve"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="选择球队" prop="coachSquadUuid" :rules="[{ required: true, message: '请选择球队', trigger: 'change' }]">
                <el-select
                  v-model.trim="batchInfo.coachSquadUuid"
                  style="width: 100%"
                  placeholder="请选择球队"
                  @change="coachSquadChange"
                  no-data-text="暂时没有球队，请前往球队管理添加球队"
                >
                  <el-option
                    v-for="item in squadCoachList"
                    :key="item.key"
                    :value="item.key"
                    :label="item.label"
                    :disabled="item.squadDissolve"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>

            <el-row>
              <el-col :span="24">
                <el-form-item label="测试时间" prop="testTime">
                  <el-date-picker
                    v-model="batchInfo.testTime"
                    type="date"
                    style="width: 100%"
                    placeholder="请选择测试时间"
                    value-format="timestamp"
                    clearable
                    :editable="false"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!--<el-col :span="10">-->
                <!--<el-time-picker-->
                  <!--v-model="time"-->
                  <!--style="margin-left: 13px; width: 208px"-->
                  <!--:editable="false"-->
                  <!--value-format="timestamp"-->
                  <!--format="HH:mm"-->
                  <!--placeholder="请选择测试时间"-->
                <!--&gt;-->
                <!--</el-time-picker>-->
              <!--</el-col>-->
            </el-row>

            <el-form-item label="测试地点" prop="testAddress">
              <el-input
                v-model="batchInfo.testAddress"
                placeholder="请输入测试地点"
              ></el-input>
            </el-form-item>
            <el-form-item label="测试海拔" prop="testRegion">
              <el-select
                v-model="batchInfo.testRegion"
                placeholder="请选择测试海拔"
                style="width: 100%"
              >
                <el-option label="高原" value="plateau" />
                <el-option label="亚高原" value="subPlateau" />
                <el-option label="平原" value="plain" />
              </el-select>
            </el-form-item>
            <el-form-item label="测试联系人姓名" prop="linkMen">
              <el-input
                v-model="batchInfo.linkMen"
                placeholder="请输入测试联系人姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="测试联系人手机号" prop="linkMenPhone">
              <el-input
                v-model="batchInfo.linkMenPhone"
                placeholder="请输入测试联系人手机号"
              ></el-input>
            </el-form-item>
            <el-form-item label="测试设备符合要求的项目" prop="templateUuid">
              <el-select
                v-model="batchInfo.templateUuid"
                placeholder="请选择测试数据模板"
                style="width: 100%"
                @change="shownIdicator"
              >
                <el-option
                  v-for="item in templateList"
                  :key="item.uuid"
                  :label="item.templateOfficial==1?item.templateTitle+' -- 官方测试':item.templateTitle"
                  :value="item.uuid"
                />
              </el-select>
            </el-form-item>
            <div class="body-template-indicator">
              <el-checkbox
                v-show="batchInfo.templateUuid"
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="batchInfo.indicatorsNormatives"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="item in indicatorList"
                  :key="item.uuid"
                  :label="item.uuid"
                  >{{ item.indicatorName }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div v-if="batchAdd">
              <div class="batchAdd_wrap">
                <el-upload
                  class="upload-demo"
                  :action="
                    '/api/zuxie/guozi/playerBodyData/upload/excel?templateUuid=' +
                    batchInfo.templateUuid
                  "
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                  :on-exceed="handleExceed"
                  :limit="1"
                >
                  <el-button type="primary">点击上传测试结果</el-button>
                </el-upload>
                <div class="tipFile">
                  请上传已经填写完成的“运动能力测试登记表”或
                  <a :href="$yioksConfig.transferBaseOnly(downloadUrl)" download="球员运动能力测试模板.xlsx">
                    <span class="color:#4cd964">{{
                      $t("uploadTipsSecond")
                    }}</span></a
                  >
                  {{ $t("uploadTipsThird") }}
                </div>
                <div v-show="file.errorNum" class="uploadError">
                  错误信息：您上传的“运动能力测试登记表”共{{
                    file.errorNum + file.foundNum
                  }}条信息，其中{{ file.errorNum }}条信息有误。请参照
                  <a :href="$yioksConfig.transferBaseOnly(file.errorExcel)" download>《错误信息列表》</a
                  >对您刚才提交的“运动能力测试登记表”进行修正，然后重新上传。
                </div>
                <el-button
                  v-show="file.successBtn"
                  type="primary"
                  style="
                    margin-top: 30px;
                    background: #409eff;
                    border-color: #409eff;
                  "
                  :loading="file.addbtnLoading"
                  @click="batchAddBoby"
                  >{{ $t("importNow") }}</el-button
                >
              </div>
            </div>
          </div>
        </vue-scroll>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import "vue-awesome/icons/regular/trash-alt";
import "vue-awesome/icons/regular/edit";
import squad from "@/api/squad";
import body from "@/api/body";
import common from "@/api/common";
import person from "@/assets/images/common/person.jpg";
import storage from "@/utils/storage";
import formRules from "@/utils/formRules";
import rulesMixin from "@/utils/formRules/rulesMixin";
import { squadNameList } from "@/utils/yioks_data";
import { ops } from "@/utils/scrollIndialog";

export default {
  name: "BodyList",

  mixins: [rulesMixin],

  data() {
    return {
      ops,
      boby: "",
      total: 0,
      page: 0,
      idx: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      person,
      organList: [],
      centerList: [],
      batchOrganList: [],
      batchCenterList: [],
      batchSquadList: [],
      squadList: [],
      official: 0,
      selectVal: {
        organUuid: "",
        youthUuid: "",
        seacherString: "",
        squadUuid: "",
      },
      batchInfo: {
        organUuid: "",
        organShortName: "",
        youthShortName: "",
        youthUuid: "",
        squadUuid: "",
        testRegion: "",
        indicatorsNormatives: [],
        templateUuid: "",
        coachSquadUuid: '', // 临时数据
      },
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      showTip: false,
      addBtnLoading: false,
      loading: true,
      addBtn: false,
      allSquad: "",
      playerOption: "",
      bobyUuid: "",
      isEdit: false,
      playerName: "",
      squadNameList,
      squadName: "",
      formRules,
      batchAdd: false,
      uploadSuccess: false,
      batchSquadUuid: "",
      templateList: [],
      indicatorList: [],
      isIndeterminate: true,
      checkAll: false,
      time: "",
      file: {
        errorNum: 0,
        foundNum: 0,
        errorExcel: "",
        foundExcel: "",
        successBtn: false,
        addbtnLoading: false,
      },
      squadCoachList: [],
      coachSquad: '',
      // downloadUrl: '/uploads/templateFile/运动能力测试登记表.xlsx',
      downloadUrl: '',
    };
  },

  watch: {
    page() {
      this.changeQuery();
    },
    batchAdd(val) {
      if (!val) {
        this.batchInfo = {
          ...this.batchInfo,
          squadUuid: "",
          testRegion: "",
          indicatorsNormatives: [],
          templateUuid: "",
        };
        // this.batchCenterList = []
        // this.batchSquadList = []
        this.$refs["batchInfo"].resetFields();
      }
    },
  },

  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
  },

  created() {
    const {
      page,
      idx,
      seacherString,
      squadUuid,
      organUuid,
      youthUuid,
    } = this.$route.query;
    page && (this.page = Number(page));
    seacherString && this.$set(this.selectVal, "seacherString", seacherString);
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
    squadUuid && this.$set(this.selectVal, "squadUuid", squadUuid);
    this.idx = Number(idx);
    if (Number(idx) === 0) this.official = 1;
    if (Number(idx) === 1) this.official = 0;
    if(this.userRole !== 'coach') {
      this.getOrganListAndCenterList();
    } else {
      this.getSearchSelectList();
    }

    this.getBobyList();
    // this.getCommonData()
    if (this.userRole === "system"){
      this.getTemplateSuper();
    } else {
      this.getTemplate();
    }

  },

  methods: {

    openDialog() {
      this.batchAdd = true
    },
    getBobyList() {
      this.loading = true;
      this.showList = false;
      this.empty = false;
      let request;
      if (this.userRole === "system" || this.userRole === "admin") {
        request = body.getBodySystem;
      } else if (this.userRole === "organ") {
        request = body.getBodyOrgan;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = body.getBodyYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = body.getBodyLeaderOrCoach;
      }
      request({ page: this.page, size: this.pageSize, ...this.selectVal, official: this.official})
        .then((res) => {
          this.loading = false;
          this.total = res.totalElements;
          if (res.content.length) {
            this.boby = res.content;
            this.showList = true;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    getCommonData() {
      common.getAllSquad().then((res) => {
        this.allSquad = res;
      });
      common.getPlayerOption().then((res) => {
        this.playerOption = res;
      });
    },
    deletBoby(uuid) {
      this.bobyUuid = uuid;
      this.showTip = true;
    },
    isDelete(isSure) {
      if (isSure) {
        body.deleteRemoveBoby({ dataUuid: this.bobyUuid }).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.getBobyList();
            this.showTip = false;
          }
        });
      } else {
        this.showTip = false;
      }
    },
    goDetail(uuid) {
      this.$router.push({
        path: "info",
        query: {
          uuid,
        },
      });
    },
    uploadSuccessCallBack() {
      this.$nextTick(() => {
        this.$refs.scroll.scrollTo({ y: "100%" });
      });
    },
    batchAddBoby() {
      this.$refs["batchInfo"].validate((valid) => {
        if (valid) {
          this.file.addbtnLoading = true;
          let data = {
            ...this.batchInfo,
            path: this.file.foundExcel,
          };
          if (!this.file.foundExcel) {
            this.file.addbtnLoading = false;
            this.$message.error("请上传格式正确的身体素质Excel文件");
            return;
          }
          const hours = new Date(this.time).getHours() * 60 * 60 * 1000;
          const minutes = new Date(this.time).getMinutes() * 60 * 1000;
          // data.testTime = data.testTime + hours + minutes;
          let indicatorsNormatives = [];
          this.indicatorList.forEach((item) => {
            let indicator = {
              indicatorUuid: item.uuid,
              standard: false,
            };
            if (data.indicatorsNormatives.includes(item.uuid)) {
              indicator.standard = true;
            }
            indicatorsNormatives.push(indicator);
          });
          data.indicatorsNormatives = indicatorsNormatives;
          body
            .batchAddPlayerBodyData(data)
            .then((res) => {
              this.file.addbtnLoading = false;
              this.$message.success("导入成功");
              this.batchAdd = false;
              this.file.successBtn = false;
              this.getBobyList();
            })
            .catch((err) => {
              this.file.addbtnLoading = false;
              this.file.successBtn = false;
              console.error(err);
            });
        }
      });
    },
    getOrganListAndCenterList() {
      let data = this.uuid;
      let request;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = squad.getOrgListByCoachOrLeader;
      }
      request(data).then((res) => {
        this.organList = res;
        this.batchOrganList = res;
        if (this.selectVal.organUuid) {
          if (this.selectVal.youthUuid) {
            this.centerList =
              this.organList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            if (this.selectVal.squadUuid) {
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
            }
          }
        } else {
          if (this.organList.length === 1) {
            this.$set(this.selectVal, "organUuid", this.organList[0].organUuid);
            this.$set(
              this.batchInfo,
              "organUuid",
              this.batchOrganList[0].organUuid
            );
            this.$set(
              this.batchInfo,
              "organShortName",
              this.batchOrganList[0].organShortName
            );
            this.centerList =
              this.batchOrganList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            this.batchCenterList = this.centerList;
            if (this.centerList.length === 1) {
              this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
              this.$set(
                this.batchInfo,
                "youthUuid",
                this.batchCenterList[0].uuid
              );
              this.$set(
                this.batchInfo,
                "youthShortName",
                this.batchCenterList[0].youthShortName
              );
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
              this.batchSquadList = this.squadList;
              if (this.squadList.length === 1) {
                this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
                this.$set(this.batchInfo, "squadUuid", this.squadList[0].uuid);
              }
            }
          }
        }
      });
    },
    getSearchSelectList() {
      const _ = require('lodash');
      squad.getSquadListCoachAll()
      .then(res => {
        if(res.code) {
          this.$message.error(res.msg)
          return
        }
        const uni_selectYouthList = _.unionBy(res, "squadUuid");
        this.squadCoachList = uni_selectYouthList.map((item) => ({
          label: `${item.organShortName} - ${item.youthShortName} - ${ item.shortName }`,
          value: item.squadUuid,
          key: JSON.stringify({
            squadUuid: item.squadUuid,
            youthUuid: item.youthUuid,
            organUuid: item.organUuid,
            organShortName: item.organShortName,
            youthShortName: item.youthShortName,
            shortName: item.shortName
             }),
          squadDissolve:item.squadDissolve,
        }));
      })
    },
    changeOrg() {
      this.centerList = [];
      this.squadList = [];
      this.$set(this.selectVal, "youthUuid", "");
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.organUuid) {
        const { youthList } = this.organList.find((item) => {
          return item.organUuid === this.selectVal.organUuid;
        });
        this.centerList = youthList || [];
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
          this.squadList =
            this.centerList.find((item) => {
              return item.uuid === this.selectVal.youthUuid;
            }).squadList || [];
          if (this.squadList.length === 1) {
            this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
          }
        }
      }
      this.changeQuery(true);
    },
    changeCenter() {
      this.squadList = [];
      this.$set(this.selectVal, "squadUuid", "");
      if (this.selectVal.youthUuid) {
        this.squadList =
          this.centerList.find((item) => {
            return item.uuid === this.selectVal.youthUuid;
          }).squadList || [];
        if (this.squadList.length === 1) {
          this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
        }
      }
      this.changeQuery(true);
    },
    changeQuery(flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          idx:this.idx,
          page: this.page,
          official: this.official,
          seacherString: this.selectVal.seacherString,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          squadUuid: this.selectVal.squadUuid,
        },
      });
      this.getBobyList();
    },
    changeBathCenter() {
      this.batchInfo.squadUuid = "";
      this.batchSquadList = [];
      this.batchInfo.youthShortName = "";
      if (this.batchInfo.youthUuid) {
        this.batchInfo.youthShortName =
          this.batchCenterList.find((item) => {
            return item.uuid === this.batchInfo.youthUuid;
          }).youthShortName || "";
        this.batchSquadList =
          this.batchCenterList.find((item) => {
            return item.uuid === this.batchInfo.youthUuid;
          }).squadList || [];
        if (this.batchSquadList.length === 1) {
          this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
        }
      }
    },
    changeBathOrg() {
      this.batchSquadList = [];
      this.batchCenterList = [];
      this.$set(this.batchInfo, "youthUuid", "");
      this.$set(this.batchInfo, "organShortName", "");
      this.$set(this.batchInfo, "youthShortName", "");
      this.$set(this.batchInfo, "squadUuid", "");
      if (this.batchInfo.organUuid) {
        this.batchInfo.organShortName = this.batchOrganList.find((item) => {
          return item.organUuid === this.batchInfo.organUuid;
        }).organShortName;
        this.batchCenterList =
          this.batchOrganList.find((item) => {
            return item.organUuid === this.batchInfo.organUuid;
          }).youthList || [];
        if (this.batchCenterList.length === 1) {
          // this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
          this.$set(this.batchInfo, "youthUuid", this.batchCenterList[0].uuid);
          this.$set(
            this.batchInfo,
            "youthShortName",
            this.batchCenterList[0].youthShortName
          );
          this.batchSquadList =
            this.batchCenterList.find((item) => {
              return item.uuid === this.batchInfo.youthUuid;
            }).squadList || [];
          if (this.batchSquadList.length === 1) {
            this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
          }
        }
      }
    },
    // 教练用
    coachSquadChange(val) {
      if(val) {
        /*
         batchInfo: {
            organUuid: "",
            organShortName: "",
            youthShortName: "",
            youthUuid: "",
            squadUuid: "",
            testRegion: "",
            indicatorsNormatives: [],
            templateUuid: "",
          },
         */
         const selectData = JSON.parse(val);
        //  const mixinData = {}
         this.batchInfo = Object.assign({}, this.batchInfo, selectData)
      } else {
        const mixinData = {
            organUuid: "",
            organShortName: "",
            youthShortName: "",
            youthUuid: "",
            squadUuid: "",
        }
        this.batchInfo = Object.assign({}, this.batchInfo, mixinData)
      }
    },
    getTemplate() {
      body.getTemplate().then((res) => {
        if (res.length) {
          this.templateList = res;
          this.batchInfo.templateUuid = this.templateList[0] ? this.templateList[0].uuid : "";
          this.downloadUrl = res[0].templateFileUrl;
        }
        this.shownIdicator();
      });
    },
    getTemplateSuper() {
      body.getTemplateSuper().then((res) => {
        if (res.length) {
          this.templateList = res;
          this.batchInfo.templateUuid = this.templateList[0] ? this.templateList[0].uuid : "";
          this.downloadUrl = res[0].templateFileUrl;
        }
        this.shownIdicator();
      });
    },
    shownIdicator() {
      this.templateList.forEach((item) => {
        if (item.uuid === this.batchInfo.templateUuid) {
          this.indicatorList = item.indicatorList;
          const { templateFileUrl } = item;
          if(templateFileUrl) this.downloadUrl = templateFileUrl;
        }
      });
    },
    handleCheckAllChange(val) {
      const allList = [];
      this.indicatorList.forEach((item) => {
        allList.push(item.uuid);
      });
      this.batchInfo.indicatorsNormatives = val ? allList : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.indicatorList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.indicatorList.length;
    },
    handleExceed() {
      this.$message.error(this.$t("uploadFileTips"));
    },
    beforeUpload(file) {
      const fileReg = /^.*\.(xls|xlsx)$/i;
      const fileType = fileReg.test(file.name);
      const fileLimit = file.size / 1024 / 1024 < 20;
      if (!fileType) {
        this.$message.error(this.$t("uploadExcelTips"));
      }
      if (!fileLimit) {
        this.$message.error(this.$t("uploadExcelSizeTips"));
      }
      return fileType && fileLimit;
    },
    handleSuccess(res) {
      this.file.errorNum = Number(res.errorExcel_total);
      this.file.foundNum = Number(res.foundExcel_total);
      this.file.errorExcel = res.errorExcel;
      this.file.foundExcel = res.foundExcel;
      if (res.code) {
        this.$message.error(
          "文件解析失败，请检查文件下方是否有多余空行，删除多余空行后重试"
        );
        return;
      }
      if (!this.file.errorNum) this.file.successBtn = true;
      this.uploadSuccessCallBack();
    },
    handleRemove() {
      this.file.errorNum = 0;
      this.file.successBtn = false;
    },
    handleClose() {
      this.file.successBtn = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';

.list_wrap {
  flex: 1;
  overflow: hidden;
  height: 460px;

  .table {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;

    // margin: 30px 0 0;
    .thead, .tbody {
      border: 1px solid $color_white;
    }

    .thead {
      margin: 0 40px;

      .tr {
        height: 45px;
        display: flex;
      }
    }

    .scrollArea {
      height: 425px;
      padding-bottom: 15px;
      /* flex 1 */
      /* overflow hidden */
    }

    .tbodyWrap {
      display: block;
      // padding: 0 40px;
    }

    .tbody {
      display: block;
      width: 810px;
      margin-left: auto;
      margin-right: auto;
      max-width: 810px;
      border-top: none;
      border-bottom: none;

      .tr {
        height: 49px;
        display: flex;
        border-bottom: 1px solid $color_white;
      }
    }

    .th, .td {
      height: 100%;
      /* flex: 1 1 auto; */
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: $font_size_medium;
      border-right: 1px solid $color_white;
    }

    .th:last-child, .td:last-child {
      border-right: none;
    }

    .td {
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: $color_white;
      }
    }
    .seq {
      width 6%
    }

    .organName {
      width: 43%;
    }

    .squadName {
      width: 25%;
    }

    .testTime {
      width: 13%;
    }

    .opt {
      width: 13%;

      p {
        width: 100%;
        text-align: center;

        .item {
          cursor: pointer;
          user-select: none;
          color: $green_color;
        }

        .split {
          margin: 0 5px;
        }
      }
    }
  }
}

.demo-ruleForm {
  height: 475px;
}

.tip {
  margin-top: 10px;
  color: red;
  width: 100%;
  text-align: center;
  word-break: break-word;
}

.select_wrap {
  position: relative;

  .remember {
    position: absolute;
    top: -22px;
    right: 0;
    color: #4cd964;
    font-weight: bold;

    a {
      color: #4cd964;
    }
  }
}
</style>
<style lang="stylus">
.body-template-indicator {
  padding-left: 135px;
  padding-bottom: 10px;

  .el-checkbox {
    padding-bottom: 10px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #4cd964;
    border-color: #4cd964;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #4cd964;
  }

  .el-checkbox__inner:hover {
    border-color: #4cd964;
  }
}
</style>
<style lang="stylus" scoped>
@import '~@/assets/css/variable';

.batchAdd_wrap {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;

  .upload-demo {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .tipFile {
    margin-top: 20px;

    span {
      color: $green_color;
      cursor: pointer;
    }
  }

  .uploadError {
    padding: 20px 50px;
    font-size: 16px;
    color: red;

    a {
      color: #5ac8fa;
    }
  }
}
</style>
